import './App.scss';
import { CommonProvider } from './context/common';
import Routing from './routes/Routing';
import { BrowserRouter } from 'react-router';

function App() {
  return (
    <CommonProvider>
      <BrowserRouter>
        <Routing />
      </BrowserRouter>
    </CommonProvider>
  );
}

export default App;
